import { MinusIcon } from "@radix-ui/react-icons";
import { PlusIcon } from "lucide-react";
import { useState } from "react";

import { preventBubble } from "@/components/canvas-editor/utils";
import { Avatar } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { SimpleTooltip } from "@/components/ui/tooltip";
import { User } from "@/lib/types";

export function AvatarList({
  users,
  maxVisible = 10,
  total,
}: {
  users: User[];
  maxVisible?: number;
  total: number;
}) {
  const [showAll, setShowAll] = useState(false);

  if (!users?.length) {
    return null;
  }

  const visible = showAll ? users.slice(0, 150) : users.slice(0, maxVisible);

  return (
    <div>
      <div className="flex flex-wrap gap-2">
        {visible.map((user) => (
          <div key={user.did} className="flex gap-2 items-center">
            <SimpleTooltip
              message={
                <div className="flex flex-col gap-1">
                  <span className="font-semibold text-sm">
                    {user.display_name || user.handle}
                  </span>
                  <span className="text-xs text-slate-dim">@{user.handle}</span>
                </div>
              }
            >
              <Avatar src={user.avatar} alt={user.handle} />
            </SimpleTooltip>
          </div>
        ))}

        {users.length > 10 && (
          <SimpleTooltip message={showAll ? "Show less" : "Show more"}>
            <Button
              size="icon"
              aria-label={showAll ? "Show less" : "Show more"}
              variant="ghost"
              className="rounded-full border border-slatea-normal bg-slatea-ui"
              {...preventBubble}
              onClick={(e) => {
                e.stopPropagation();
                setShowAll(!showAll);
              }}
            >
              {showAll ? <MinusIcon /> : <PlusIcon />}
            </Button>
          </SimpleTooltip>
        )}
      </div>

      {total > visible.length && showAll && (
        <div className="flex gap-2 items-center">
          <span className="text-xs text-slate-dim py-3 px-2">
            And {total - visible.length} more...
          </span>
        </div>
      )}
    </div>
  );
}
